
import { useState } from "react";
import { TerraceSubmission } from "@/types/terrace";
import { useSubmissionViewing } from "./useSubmissionViewing";
import { useSubmissionApproval } from "./useSubmissionApproval";
import { useSubmissionDeletion } from "./useSubmissionDeletion";

export const useSubmissionActions = (fetchSubmissions: () => void) => {
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [submissionToDelete, setSubmissionToDelete] = useState<TerraceSubmission | null>(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const {
    selectedSubmission,
    isDialogOpen,
    setIsDialogOpen,
    form,
    handleViewSubmission,
  } = useSubmissionViewing();

  const { handleApprove: approveSubmission, handleReject: rejectSubmission } = useSubmissionApproval(fetchSubmissions);
  const { deleteSubmission } = useSubmissionDeletion(fetchSubmissions);

  const handleApprove = () => {
    approveSubmission(selectedSubmission, form, setIsDialogOpen);
  };

  const handleReject = () => {
    rejectSubmission(selectedSubmission, setIsDialogOpen);
  };

  const handleDeleteRequest = (submission: TerraceSubmission) => {
    setSubmissionToDelete(submission);
    setDeleteDialogOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!submissionToDelete) return;
    
    setIsDeleting(true);
    try {
      const success = await deleteSubmission(submissionToDelete.id);
      if (success) {
        setDeleteDialogOpen(false);
        setSubmissionToDelete(null);
      }
    } finally {
      setIsDeleting(false);
    }
  };

  return {
    selectedSubmission,
    isDialogOpen,
    setIsDialogOpen,
    form,
    handleViewSubmission,
    handleApprove,
    handleReject,
    handleDeleteRequest,
    deleteDialogOpen,
    setDeleteDialogOpen,
    submissionToDelete,
    handleConfirmDelete,
    isDeleting,
  };
};
